import { Heart } from "lucide-react";

export function Logo({ inverse, size = "md" }) {
  return (
    <span className="flex items-center gap-2">
      <span className={`flex items-center justify-center rounded-full bg-primary ${size === "lg" ? "h-[52px] w-[52px]" : "h-[34px] w-[34px]"}`}>
        <Heart className={`${size === "lg" ? "h-[22px] w-[22px]" : "h-[18px] w-[18px]"} fill-white text-white`} />
      </span>
      {size !== "lg" ? <span className={`whitespace-nowrap font-display text-2xl font-bold tracking-[3px] ${inverse ? "text-[#FDFBF7]" : "text-foreground"}`}>LOVE NET</span> : null}
    </span>
  );
}
